// Kritik murojaatlar — YAGONA manba.
//
// Bu ro'yxatni endi ikki joy ko'rsatadi: yon paneldagi "Kritik" bloki va
// telefondagi pastki qatorning alohida doirasi. Har biri o'zi so'rov yuborsa,
// backend bir xil ma'lumot uchun 10 soniyada ikki marta bezovta qilinardi va
// ikkala raqam bir zumga bo'lsa ham FARQ qilishi mumkin edi — operator uchun
// bu "qaysi biri to'g'ri?" degan savol.
//
// Shuning uchun so'rov modul darajasida bitta: nechta komponent obuna
// bo'lishidan qat'i nazar bitta interval ishlaydi, hammasi bir xil javobni
// oladi. Oxirgi obunachi ketganda interval o'chadi — masalan kompyuterda
// pastki qator umuman chizilmaydi, ya'ni ortiqcha so'rov ham bo'lmaydi.

import { useEffect, useState } from 'react'
import { ticketsApi } from '../api'
import { useStore } from '../store'

const POLL_MS = 10000

// Yopilgan murojaat kritik hisoblanmaydi — u endi ish emas, tarix.
const isOpen = (t) => !['resolved', 'closed'].includes(t.status)

let cache = []
const listeners = new Set()
let timer = null

async function fetchNow() {
  try {
    const res = await ticketsApi.list({ priority: 'critical', limit: 20 })
    cache = (res.items || []).filter(isOpen)
    listeners.forEach((fn) => fn(cache))
  } catch {
    // Tarmoq uzilishi ro'yxatni TOZALAMAYDI: eski raqam yo'q raqamdan yaxshi,
    // aks holda ulanish sakraganda kritiklar ko'zdan g'oyib bo'lardi.
  }
}

/**
 * Ochiq kritik murojaatlar va ular ustidagi hisoblagichlar.
 *
 * @returns {{ tickets: Array, extra: Array, pending: number, total: number }}
 *   `extra`   — WebSocket orqali kelgan, ro'yxatda hali yo'q ogohlantirishlar
 *   `pending` — hali qabul qilinmagani: aynan shu raqam belgida ko'rsatiladi
 *   `total`   — barcha ochiq kritiklar
 */
export function useCriticalTickets() {
  const [tickets, setTickets] = useState(cache)
  const sosAlerts  = useStore((s) => s.sosAlerts)
  const criticalKey = useStore((s) => s.criticalKey)

  useEffect(() => {
    listeners.add(setTickets)
    if (listeners.size === 1) {
      fetchNow()
      timer = setInterval(fetchNow, POLL_MS)
    } else {
      setTickets(cache)   // kech qo'shilgan obunachi darhol joriy holatni oladi
    }
    return () => {
      listeners.delete(setTickets)
      if (listeners.size === 0) {
        clearInterval(timer)
        timer = null
      }
    }
  }, [])

  // Yangi kritik keldi (WebSocket) — ro'yxat intervalni kutmaydi
  useEffect(() => { if (criticalKey > 0) fetchNow() }, [criticalKey])

  // Ogohlantirish ro'yxatdagi murojaatni takrorlamasin: `seen.add` filtr
  // ichida ataylab — bir xil raqamli ikkinchi ogohlantirish ham tushib qoladi.
  const seen  = new Set(tickets.map((t) => t.ticket_number))
  const extra = sosAlerts.filter((a) => !seen.has(a.ticket_number) && seen.add(a.ticket_number))

  return {
    tickets,
    extra,
    pending: tickets.filter((t) => t.status === 'new').length + extra.length,
    total:   tickets.length + extra.length,
  }
}
